module.exports = __webpack_public_path__ + "img/window.08bee5dc.png";